import type { Configuration } from '@azure/msal-browser';
import { PublicClientApplication } from '@azure/msal-browser';

const LOGIN_MICROSOFT_ONLINE_URL = `https://login.microsoftonline.com/${import.meta.env.VITE_PUBLIC_AZURE_AD_TENANT_ID}`;

const config: Configuration = {
  auth: {
    authority: LOGIN_MICROSOFT_ONLINE_URL,
    clientId: `${import.meta.env.VITE_PUBLIC_MSAL_CLIENT_ID}`,
    redirectUri: `${import.meta.env.VITE_PUBLIC_MSAL_REDIRECT_URL}`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const loginRequest = {
  scopes: [
    `api://${import.meta.env.VITE_PUBLIC_MSAL_CLIENT_ID}/access_as_user`,
  ],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export const msalInstance = new PublicClientApplication(config);
